export default __webpack_public_path__ + "static/media/plur.53fcbbfb.png";